/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CrmIssue, IssueCheckList} from 'compob2b-libs';
import {IssueChecklistStore} from './issue-checklist.store';

@Component({
    selector: 'app-issue-checklist',
    templateUrl: './issue-checklist.component.html',
    styleUrls: ['./issue-checklist.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IssueChecklistComponent implements OnInit, AfterViewInit {

  @Input() issue: CrmIssue;
  @Input() showComponent: boolean;
  @Input() add: boolean = false;

  form: FormGroup;
  checkListItemControl: FormControl;
  editCheckListItem: IssueCheckList;
  private headerInput: ElementRef;
  @ViewChild('headerInput', {static: false}) set content(content: ElementRef) {
    if (content) {
      this.headerInput = content;
    }
  }

  constructor(public readonly store: IssueChecklistStore) {
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      header: new FormControl('')
    });
    this.checkListItemControl = new FormControl('', Validators.required);
  }

  get header(): string {
    return this.form.get('header').value;
  }

  ngAfterViewInit(): void {
    this.store.load(this.issue.id);
  }

  onSubmit() {
    if (this.form.valid && this.header) {
      this.store.store(this.issue.id, this.header);
      this.form.reset();
    }
  }

  toggle(item: IssueCheckList) {
    this.store.update(item);
  }

  delete(item: IssueCheckList) {
    item.deleted = true;
    this.store.delete(item);
  }

  edit(item: IssueCheckList) {
    this.editCheckListItem = item;
    this.checkListItemControl.patchValue(item.header);
  }

  cancel() {
    this.editCheckListItem = null;
  }

  update() {
    if (this.checkListItemControl.valid && this.editCheckListItem && this.checkListItemControl.value !== this.editCheckListItem.header) {
      this.editCheckListItem.header = this.checkListItemControl.value;
      this.store.update(this.editCheckListItem);
    }
    this.editCheckListItem = null;
  }

  toggleAdd() {
    this.add = !this.add;
  }
}
